enum AppRoutes {
  Root = '/',
  SignIn = '/sign-in',
  SignOut = '/sign-out',
  ForgotPassword = '/forgot-password',
  CreatePassword = '/create-password/:id/:token',
  ChangePassword = '/update-password/:id/:token',

  // protected routes bellow
  Communities = '/communities',
  CommunityDetails = '/communities/:communityName',
  EditCommunityPriorityByOYO = '/communities/:communityName/edit-priority',
  AddNewCommunity = '/communities/add-new-community',
  CheckCommunityAvailability = '/communities/check-availability',
  Members = '/members',
  EditCommunityPriorityByPMO = '/members/edit-priority',
  AddNewConsumer = '/members/add-new-consumer',
  MyCommunity = '/my-community',
  Documents = '/documents',
  Payments = '/payments',
  Forum = '/forum',
  AddNewProducer = '/members/add-new-producer',
  Dashboard = '/dashboard',
  FinancialData = '/financial-data',
  Reports = '/reports',
  Profile = '/profile',
  Settings = '/settings',
  EnergyData = '/energy-data',
  MemberDashboard = '/members/:id',
  MemberPrmForm = '/members/:id/add-new-prm',
  AddPayment = '/add-payment',
  PaymentResult = '/payment-result',
  Pricing = '/pricing',
  TaxPrices = '/pricing/coefficients',
  HelpCenter = '/help-center',
}

export default AppRoutes;
